import type { ComponentProps } from 'react'
import { tv } from '@joyful/utils'
import type { VariantProps } from '@joyful/utils'

export const pageMainVariants = tv({
  base: 'w-full',

  defaultVariants: {
    background: 'none',
    container: false,
    grow: 'auto',
    padding: 'page',
    position: 'static',
  },

  variants: {
    background: {
      muted: 'bg-tremor-background-muted',
      none: null,
      warm: 'bg-tremor-background-warm',
    },

    container: {
      false: null,
      true: '@container',
    },

    grow: {
      auto: null,
      fill: 'flex flex-1 flex-col',
    },

    padding: {
      compact: 'py-4 px-2 sm:px-6 lg:px-8',
      horizontal: 'px-2 sm:px-6 lg:px-8',
      none: null,
      page: 'py-6 md:py-8 px-2 sm:px-6 lg:px-8',
      // Needs an ancestor `@container`; both gutters match the wide table-of-contents rail.
      pageWithTableOfContents: 'py-6 md:py-8 px-2 sm:px-6 lg:px-8 @7xl:px-20',
      vertical: 'py-6 md:py-8',
    },

    position: {
      relative: 'relative',
      static: null,
    },
  },
})

export type PageMainProps = Omit<ComponentProps<'main'>, 'className'> &
  VariantProps<typeof pageMainVariants>

export function PageMain({
  background,
  children,
  container,
  grow,
  padding,
  position,
  ref,
  ...props
}: PageMainProps) {
  return (
    <main
      ref={ref}
      {...props}
      className={pageMainVariants({
        background,
        container,
        grow,
        padding,
        position,
      })}
    >
      {children}
    </main>
  )
}
